import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import DtvAvatar from "@directv-digital/dds.ui.dtv-avatar";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import { EqualHeightContext } from "react-equal-height/clean";

export interface PackageFeatureListProps {
  packageCardVariant: string;
  features: string[];
  textColor?: string;
  comparePackagesCta?: string;
  openComparePackagesModal: () => void;
  mduVariant?: string;
  id: string;
  noTopBorder?: boolean;
}

export const PackageFeatureList = props => {
  try{
    const {
      packageCardVariant,
      features,
      textColor,
      comparePackagesCta,
      openComparePackagesModal,
      mduVariant,
      id,
      noTopBorder,
      listIcon
    } = props || null;

    const { setForceUpdate: forceUpdate   } = React.useContext(EqualHeightContext);

    React.useEffect(() => {
      forceUpdate && forceUpdate(value => !value);
    }, [features]);

    const getCheckMarkSource = () => {
      if (packageCardVariant === "progressive-package-card" && !noTopBorder) {
        return mduVariant ?
          listIcon || "https://www.directv.com/dtvassets/global/icons/2022/check-fill-blue900-jet-fusion.svg" :
          listIcon || "https://www.directv.com/dtvassets/global/icons/fusion/check-jet-filled.svg";
      }
      return listIcon || "https://www.directv.com/dtvassets/global/icons/2022/list-checkmark_ozone.svg";
    };

    return (
    <>
      <List
        id={id}
        sx={{
          pt: "0px",
          pb: "0px",
          ...(packageCardVariant === "progressive-package-card" && {
            margin: "8px 0 0 0"
          })
        }}
      >
        {features?.map((value, index) => (
          <ListItem
            id={`${id}-${index}`}
            key={index}
            sx={{
              p: "0 0 20px 0",
              ...(packageCardVariant === "progressive-package-card" && {
                padding: "0 0 12px 0"
              })
            }}
          >
            <DtvBox
              sx={{
                display: "flex",
                alignItems: "baseline"
              }}
            >
              <DtvAvatar
                alt="checkmark"
                src={getCheckMarkSource()}
                sx={{
                  width: "16px",
                  height: "16px",
                  alignSelf: "normal",
                  ...props?.iconStyle
                }}
              />
              <DtvText
                component={value?.component || "div"}
                content={value?.content}
                variant="smalltext"
                analytics={{
                  linkPosition: 'panel_plan card'
                }}
                cta={{
                  label: value?.cta?.label || "",
                  legalUrl: value?.cta?.legalUrl,
                  position: value?.cta?.position
                }}
                sx={{
                  color: `${textColor}`,
                  padding: "0 0 0 4px",
                  fontFamily: "roboto-regular",
                  ...(packageCardVariant ===
                    "progressive-package-card" && {
                    padding: "0 0 0 8px"
                  }),
                  '& a:focus': {
                    outline: '2px solid #2E70BD',
                    padding: '0 5px'
                  }
                }}
                tooltip={{
                  content: value?.tooltip?.content,
                  position: value?.tooltip?.position,
                  mode: value?.tooltip?.mode
                }}
                {...(packageCardVariant ===
                  "progressive-package-card" && {
                  variant: "body3medium"
                })}
              />
            </DtvBox>
          </ListItem>
        ))}
      </List>
      {comparePackagesCta?.label && (
        <DtvButton
          inline={true}
          typographyVariant="body3"
          variant="uxlink"
          sx={{
            color: "#2E70BD"
          }}
          onClick={openComparePackagesModal}
          {...comparePackagesCta}
          id={`${id}-cmpr-pkg-cta`}
        />
      )}
    </>);
  } catch (error) {
    return <ErrorDisplay error={error} />
  }
};
